let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cd4wS")).then(() => parcelRequire('RS2wE'));